import request from "@/utils/request";

/**
 *  登录
 * @param {*} data
 * @returns
 */
export function fetchLogin(data) {
  return request({
    url: "/api/user/login",
    method: "post",
    data,
  });
}

/**
 * 根据common_token获取子系统的登录信息
 * @param {*} data
 * @returns
 */
export function fetchSubLogin(data) {
  return request({
    url: "/api/user/subLogin",
    method: "post",
    data,
  });
}
